import { initials, avatarStyle } from "@/lib/format";

export function InitialsAvatar({ name, size = 40, className = "" }) {
  return (
    <span
      className={`inline-flex shrink-0 items-center justify-center rounded-md font-bold ${className}`}
      style={{ width: size, height: size, fontSize: size * 0.36, ...avatarStyle(name) }}
      aria-hidden
    >
      {initials(name)}
    </span>
  );
}
